

import * as ZapparThree from "@zappar/zappar-threejs";

let mask : any;

export function initMask(faceTrackerGroup : ZapparThree.FaceAnchorGroup){
    mask = new ZapparThree.HeadMaskMeshLoader().load();
    mask.visible = false
    faceTrackerGroup.add(mask);
}

export function maskUpdate(faceTrackerGroup : ZapparThree.FaceAnchorGroup){
    mask.updateFromFaceAnchorGroup(faceTrackerGroup);
}

export function revealMask(){
    mask.visible = true;

}

export function hideMask(){
    mask.visible = false;
}